import { DateTime } from "luxon"

//PrimeReact
import { Tooltip } from "primereact/tooltip"

//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

import RenderFormulaConnector from "./RenderFormulaConnector"
import RenderFormulaClose from "./RenderFormulaClose"
import elementTypes from "../../Elements/elementTypes"

export default function RenderFormulaQuestion({
  formulaOrder,
  dndRef,
  dndStyle,
  dndAttributes,
  dndListeners,
  hideConnector,
  overConnectorId,
}) {
  const titleIsTooLong = formulaOrder.question.title?.length > 100
  const tooltipTarget = `tt-questionTitle-${DateTime.now().toFormat(
    "yyyyMMddHHmmssSSS"
  )}`

  let typeProfile = undefined

  if (formulaOrder?.question?.questionId) {
    typeProfile = elementTypes.findTypeProfile(formulaOrder.question.type)
  } else if (formulaOrder?.question?.questionGroupId) {
    typeProfile = elementTypes.findTypeProfile(elementTypes.groupElementId)
  }

  if (formulaOrder) {
    return (
      <div
        className={`${myStyles.formulaRenderLayout} ${
          hideConnector ? myStyles.formulaRenderLayoutNoConnect : ""
        }`}
        ref={dndRef}
        style={dndStyle}
        {...dndAttributes}
        {...dndListeners}
      >
        {titleIsTooLong && (
          <Tooltip
            target={`.${tooltipTarget}`}
            className={myStyles.functionToolTip}
          />
        )}
        <div
          className={`${myStyles.formulaRenderLayoutBody} ${
            myStyles.formulaRenderBodyQuestion
          } ${titleIsTooLong ? tooltipTarget : ""}`}
          data-pr-tooltip={formulaOrder.question.title}
          data-pr-position="bottom"
        >
          <div className={myStyles.formulaRenderBodyQuestionIcon}>
            <span className="material-icons">{typeProfile?.icon}</span>
          </div>
          <div className={myStyles.formulaRenderBodyQuestionBody}>
            {titleIsTooLong
              ? formulaOrder.question.title.substring(0, 100) + "..."
              : formulaOrder.question.title}
          </div>
        </div>
        {!hideConnector ? (
          <div className={myStyles.formulaRenderLayoutConnector}>
            <RenderFormulaConnector
              connector={formulaOrder.question.connectingOperator}
              formulaId={formulaOrder?.id}
              overConnectorId={overConnectorId}
            />
          </div>
        ) : null}
        <RenderFormulaClose formulaOrderid={formulaOrder.id} />
      </div>
    )
  } else {
    return <>Unknown formula object</>
  }
}
